import UsuarioPage from './pages/UsuarioPage.vue'
import MeuPerfilPage from './pages/MeuPerfilPage.vue'
import UsuarioModuloAssociacaoPage from './pages/UsuarioModuloAssociacaoPage.vue'

const routes = [
  {
    path: 'usuarios',
    name: 'usuarios',
    component: UsuarioPage
  },
  {
    path: 'usuarios/:usuario/meu-perfil/',
    name: 'meu-perfil',
    component: MeuPerfilPage
  },
  {
    path: 'usuarios/:usuario/modulos',
    name: 'usuario-modulos',
    component: UsuarioModuloAssociacaoPage,
    meta: { requiresModule: false }
  }
];

export default routes;